import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class MemberService {
  public memberListRef: firebase.database.Reference;

  constructor(private db: AngularFireDatabase) {
    this.memberListRef = db.database.ref('/users');
  }

  getMembers() {
    return this.memberListRef;
  }

  getUserNetworks(uid) {
    // pulls existing network object
    return this.memberListRef.child(`${uid}/userNetworks`);
  }

  addUserNetwork(uid, networks) {
    // replaces network object with network object updated by app
    return this.memberListRef.child(`${uid}/userNetworks`).push({id: networks});
    console.log('network added');
  }
}
